import { render, staticRenderFns } from "./HeaderMenuLink.vue?vue&type=template&id=b4fa3a38&scoped=true&"
import script from "./HeaderMenuLink.vue?vue&type=script&lang=js&"
export * from "./HeaderMenuLink.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMenuLink.vue?vue&type=style&index=0&id=b4fa3a38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4fa3a38",
  null
  
)

export default component.exports